import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

// 提示词管理
// const tips: RouteRecordRaw = {
//   path: '/sys/tips',
//   name: 'tips',
//   meta: {
//     title: $t('route.tips.title'),
//     icon: 'ic:twotone-tips-and-updates',
//   },
//   component: () => import('@/views/sys/tips/tipsIndex.vue'),
// }

// 用户账号管理
const account: RouteRecordRaw = {
  path: '/sys/account',
  name: 'account',
  meta: {
    title: $t('route.account.title'),
    icon: 'hugeicons:user-account',
  },
  component: () => import('@/views/sys/user_account/accountIndex.vue'),
}

// 用户角色管理
// const role: RouteRecordRaw = {
//   path: '/sys/role',
//   name: 'role',
//   meta: {
//     title: $t('route.role.title'),
//     icon: 'eos-icons:role-binding-outlined',
//   },
//   component: () => import('@/views/sys/user_role/roleIndex.vue'),
// }

// 通知管理
const notice: RouteRecordRaw = {
  path: '/sys/notice',
  name: 'notice',
  meta: {
    title: $t('route.notice.title'),
    icon: 'icon-park-outline:volume-notice',
  },
  component: () => import('@/views/sys/notice/index.vue'),
}

// 通知配置
const noticeConfitg: RouteRecordRaw = {
  path: '/sys/noticeConfig',
  name: 'noticeConfig',
  meta: {
    title: $t('route.notice.noticeConfig'),
    // 通知配置的图标
    icon: 'hugeicons:notification-01',
  },
  component: () => import('@/views/sys/noticeConfig/index.vue'),
}

// 统计分析
// const statistics: RouteRecordRaw = {
//   path: '/sys/statistics',
//   name: 'statistics',
//   meta: {
//     title: $t('route.statistics.title'),
//     icon: 'wpf:statistics',
//   },
//   component: () => import('@/views/sys/statistics/statisticsIndex.vue'),
// }

const routes: RouteRecordRaw = {
  path: '/sys',
  component: Layout,
  name: 'sys',
  meta: {
    title: $t('route.sys.title'),
    icon: 'hugeicons:system-update-01',
    alwaysOpened: false,
  },
  children: [
    // tips,
    // userData,
    account,
    // role,
    notice,
    noticeConfitg,
    // statistics,

  ],
}
export default routes
